
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hire-us",
      function () {
        return require("private-next-pages/hire-us/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hire-us"])
      });
    }
  